import { IconButton } from "@mui/material";
import React, { Fragment, useState } from "react";
import { FiTablet } from "react-icons/fi";
import propTypes from "prop-types";

import styles from "../../../devices_admin/components/listItems/styles";
import flex from "../../../../../styles/flex";
import { DeviceDeactivateHistory } from "../../../../../logic/api";
import { useDate } from "../../../../../utility/useDate";
import { useTranslation } from "react-i18next";

const DeviceDeActivationListItem: React.FunctionComponent<{
    history: DeviceDeactivateHistory,

}> = (props) => {

    const [device] = useState(props.history.device);
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();

    let lastUser = [props.history?.deActivatedBy?.firstName ?? "", props.history?.deActivatedBy?.lastName ?? ""].filter((n) => n.length > 0).join(" ");
    if (lastUser.length == 0) lastUser = "-";

    return (
        <Fragment>
            <div style={styles.listItem}>
                <div style={{ ...flex.flexRows, justifyContent: "center", alignItems: "center" }}>

                    <div style={flex.flexAuto}>

                        <div style={{ marginRight: 10 }}>
                            <IconButton disabled={true}>
                                <FiTablet color={"black"}></FiTablet>
                            </IconButton>
                        </div>
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>

                        <div>
                            <b>{((device?.alias ?? "").length > 0 ? device?.alias : device?.name) ?? t("mobile.noName")}</b>
                        </div>
                        {
                            (device?.alias ?? "").length > 0 && (
                                <div style={{ marginBottom: 5 }}>
                                    {device?.name}
                                </div>
                            )
                        }

                        {
                            (device?.appVersion ?? "").length > 0 && (
                                <div>
                                    <b>{device?.appVersion}</b>
                                </div>
                            )
                        }
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            {t("mobile.deactivated")}
                        </div>
                        <div>
                            <b>{toFormattedDateTimeString(props.history.dated ?? undefined)}</b>
                        </div>
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            {t("mobile.deactivatedBy")}
                        </div>
                        <div>
                            <b>{lastUser}</b>
                        </div>
                    </div>

                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            {t("mobile.lastSync")}:
                        </div>
                        <div>
                            <b>{(device?.lastSyncDate == null) ? "NEVER" : toFormattedDateTimeString(device.lastSyncDate)}</b>
                        </div>
                    </div>

                </div>
            </div >

        </Fragment>
    );
}

DeviceDeActivationListItem.propTypes = {
    history: propTypes.any.isRequired,

}

export default DeviceDeActivationListItem;


